<template>
  <div>

    <div class="form-group mx-2 w-full">
      <p-check class="p-default p-fill" color="primary" v-model="dossier.is_preliminary">
        Aufrissakte
      </p-check>
    </div>

    <section-box title="Stammdaten">
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/4">
          <label class="form-label">Nummer</label>
          <input type="text" class="input w-full" v-model="dossier.token"
                 v-bind:class="{ 'input-error': errors.token }"/>
          <div class="input-error-message" v-if="errors.token">{{ errors.token[0] }}</div>
        </div>
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Name</label>
          <input type="text" class="input w-full" v-model="dossier.name" v-bind:class="{ 'input-error': errors.name }"/>
          <div class="input-error-message" v-if="errors.name">{{ errors.name[0] }}</div>
        </div>
      </div>
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/4">
          <label class="form-label">Prozessbevollmächtigter</label>
          <select v-model="dossier.attorney_id" class="input w-full">
            <option v-for="attorney in attorneys" :key="attorney[1]" :value="attorney[1]">
              {{ attorney[0] }}
            </option>
          </select>
          <div class="input-error-message" v-if="errors.attorney_id">{{ errors.attorney_id[0] }}</div>
        </div>
        <div class="form-group mx-2 w-1/4">
          <label class="form-label">Streitwert</label>
          <currency-input
              v-model="dossier.jurisdictional_amount"
              currency="EUR"
              locale="de"
              class="input w-full"
          />
          <div class="input-error-message" v-if="errors.jurisdictional_amount">{{ errors.jurisdictional_amount[0] }}
          </div>
        </div>
      </div>
      <div class="flex w-full">
        <div class="form-group mx-2 w-full">
          <label class="form-label">Wichtige Notiz</label>
          <input type="text" class="input w-full" v-model="dossier.important_note" v-bind:class="{ 'input-error': errors.important_note }"/>
          <div class="input-error-message" v-if="errors.important_note">{{ errors.important_note[0] }}</div>
        </div>
      </div>
      <div class="flex w-full">
        <div class="form-group mx-2 w-full">
          <label class="form-label">Notizen</label>
          <textarea class="w-full input" v-model="dossier.notes" rows="5">{{ dossier.notes }}</textarea>
          <div class="input-error-message" v-if="errors.notes">{{ errors.notes[0] }}</div>
        </div>
      </div>
    </section-box>


    <section-box title="Angaben zum Mandanten">
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/4">
          <label class="form-label">Anrede</label>
          <select v-model="dossier.principal_salutation" class="input w-full">
            <option v-for="principalSalutation in principalSalutations" :key="principalSalutation[1]"
                    :value="principalSalutation[1]">
              {{ principalSalutation[0] }}
            </option>
          </select>
          <div class="input-error-message" v-if="errors.token">{{ errors.token[0] }}</div>
        </div>
        <div class="form-group mx-2 w-3/4">
          <label class="form-label">Name</label>
          <input type="text" class="input w-full" v-model="dossier.principal_name"
                 v-bind:class="{ 'input-error': errors.principal_name }"/>
          <div class="input-error-message" v-if="errors.principal_name">{{ errors.principal_name[0] }}</div>
        </div>
      </div>
      <div class="form-group mx-2 w-full">
        <label class="form-label">Strasse und Hausnummer</label>
        <input type="text" class="input w-full" v-model="dossier.principal_street"
               v-bind:class="{ 'input-error': errors.principal_street }"/>
        <div class="input-error-message" v-if="errors.principal_street">{{ errors.principal_street[0] }}</div>
      </div>
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/4">
          <label class="form-label">PLZ</label>
          <input type="text" class="input w-full" v-model="dossier.principal_zip"
                 v-bind:class="{ 'input-error': errors.principal_zip }"/>
          <div class="input-error-message" v-if="errors.principal_zip">{{ errors.principal_zip[0] }}</div>
        </div>
        <div class="form-group mx-2 w-3/4">
          <label class="form-label">Stadt</label>
          <input type="text" class="input w-full" v-model="dossier.principal_city"
                 v-bind:class="{ 'input-error': errors.principal_city }"/>
          <div class="input-error-message" v-if="errors.principal_city">{{ errors.principal_city[0] }}</div>
        </div>
      </div>
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">E-Mail</label>
          <input type="text" class="input w-full" v-model="dossier.principal_email"
                 v-bind:class="{ 'input-error': errors.principal_email }"/>
          <div class="input-error-message" v-if="errors.principal_email">{{ errors.principal_email[0] }}</div>
        </div>
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Telefon</label>
          <input type="text" class="input w-full" v-model="dossier.principal_phone"
                 v-bind:class="{ 'input-error': errors.principal_phone }"/>
          <div class="input-error-message" v-if="errors.principal_phone">{{ errors.principal_phone[0] }}</div>
        </div>
      </div>
    </section-box>


    <section-box title="Hersteller">
      <div class="form-group mx-2 w-full">
        <p-check class="p-default p-fill" color="primary" v-model="dossier.use_own_defendant_data">Eigene Angaben
          verwenden
        </p-check>
      </div>

      <div v-if="!dossier.use_own_defendant_data" class="w-full">
        <div class="form-group mx-2">
          <select v-model="dossier.defendant_id" class="input">
            <option v-for="defendant in defendants" :key="defendant[1]"
                    :value="defendant[1]">
              {{ defendant[0] }}
            </option>
          </select>
        </div>
      </div>

      <div v-else class="w-full">
        <div class="form-group mx-2 w-full">
          <label class="form-label">Herstellername</label>
          <input type="text" class="input w-full" v-model="dossier.defendant_company_name"
                 v-bind:class="{ 'input-error': errors.defendant_company_name }"/>
          <div class="input-error-message" v-if="errors.defendant_company_name">{{
              errors.defendant_company_name[0]
            }}
          </div>
        </div>
        <div class="form-group mx-2 w-full">
          <label class="form-label">Vorstand</label>
          <input type="text" class="input w-full" v-model="dossier.defendant_chairman"
                 v-bind:class="{ 'input-error': errors.defendant_chairman }"/>
          <div class="input-error-message" v-if="errors.defendant_chairman">{{ errors.defendant_chairman[0] }}</div>
        </div>
        <div class="form-group mx-2 w-full">
          <label class="form-label">Strasse und Hausnummer</label>
          <input type="text" class="input w-full" v-model="dossier.defendant_street"
                 v-bind:class="{ 'input-error': errors.defendant_street }"/>
          <div class="input-error-message" v-if="errors.defendant_street">{{ errors.defendant_street[0] }}</div>
        </div>
        <div class="flex w-full">
          <div class="form-group mx-2 w-1/4">
            <label class="form-label">PLZ</label>
            <input type="text" class="input w-full" v-model="dossier.defendant_zip"
                   v-bind:class="{ 'input-error': errors.defendant_zip }"/>
            <div class="input-error-message" v-if="errors.defendant_zip">{{ errors.defendant_zip[0] }}</div>
          </div>
          <div class="form-group mx-2 w-3/4">
            <label class="form-label">Stadt</label>
            <input type="text" class="input w-full" v-model="dossier.defendant_city"
                   v-bind:class="{ 'input-error': errors.defendant_city }"/>
            <div class="input-error-message" v-if="errors.defendant_city">{{ errors.defendant_city[0] }}</div>
          </div>
        </div>
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Fax</label>
          <input type="text" class="input w-full" v-model="dossier.defendant_fax"
                 v-bind:class="{ 'input-error': errors.defendant_fax }"/>
          <div class="input-error-message" v-if="errors.defendant_fax">{{ errors.defendant_fax[0] }}</div>
        </div>
      </div>
    </section-box>


    <section-box title="Händler">
      <div class="form-group mx-2 w-full">
        <label class="form-label">Händlername</label>
        <input type="text" class="input w-full" v-model="dossier.defendant_dealer_company_name"
               v-bind:class="{ 'input-error': errors.defendant_dealer_company_name }"/>
        <div class="input-error-message" v-if="errors.defendant_dealer_company_name">
          {{errors.defendant_dealer_company_name[0]}}
        </div>
      </div>
      <div class="form-group mx-2 w-full">
        <label class="form-label">Vorstand</label>
        <input type="text" class="input w-full" v-model="dossier.defendant_dealer_chairman"
               v-bind:class="{ 'input-error': errors.defendant_dealer_chairman }"/>
        <div class="input-error-message" v-if="errors.defendant_dealer_chairman">{{ errors.defendant_dealer_chairman[0] }}</div>
      </div>
      <div class="form-group mx-2 w-full">
        <label class="form-label">Strasse und Hausnummer</label>
        <input type="text" class="input w-full" v-model="dossier.defendant_dealer_street"
               v-bind:class="{ 'input-error': errors.defendant_dealer_street }"/>
        <div class="input-error-message" v-if="errors.defendant_dealer_street">{{ errors.defendant_dealer_street[0] }}</div>
      </div>
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/4">
          <label class="form-label">PLZ</label>
          <input type="text" class="input w-full" v-model="dossier.defendant_dealer_zip"
                 v-bind:class="{ 'input-error': errors.defendant_dealer_zip }"/>
          <div class="input-error-message" v-if="errors.defendant_dealer_zip">{{ errors.defendant_dealer_zip[0] }}</div>
        </div>
        <div class="form-group mx-2 w-3/4">
          <label class="form-label">Stadt</label>
          <input type="text" class="input w-full" v-model="dossier.defendant_dealer_city"
                 v-bind:class="{ 'input-error': errors.defendant_dealer_city }"/>
          <div class="input-error-message" v-if="errors.defendant_dealer_city">{{ errors.defendant_dealer_city[0] }}</div>
        </div>
      </div>
      <div class="form-group mx-2 w-1/2">
        <label class="form-label">E-Mail</label>
        <input type="text" class="input w-full" v-model="dossier.defendant_dealer_email"
               v-bind:class="{ 'input-error': errors.defendant_dealer_email }"/>
        <div class="input-error-message" v-if="errors.defendant_dealer_email">{{ errors.defendant_dealer_email[0] }}</div>
      </div>
    </section-box>


    <section-box title="Gegnerischer Anwalt">
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Name</label>
          <input type="text" class="input w-full" v-model="dossier.defendant_lawyer"
                 v-bind:class="{ 'input-error': errors.defendant_lawyer }"/>
          <div class="input-error-message" v-if="errors.defendant_lawyer">{{ errors.defendant_lawyer[0] }}</div>
        </div>
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Aktenzeichen</label>
          <input type="text" class="input w-full" v-model="dossier.defendant_lawyer_reference_number"
                 v-bind:class="{ 'input-error': errors.defendant_lawyer_reference_number }"/>
          <div class="input-error-message" v-if="errors.defendant_lawyer_reference_number">{{ errors.defendant_lawyer_reference_number[0] }}</div>
        </div>
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">E-Mail</label>
          <input type="text" class="input w-full" v-model="dossier.defendant_lawyer_email"
                 v-bind:class="{ 'input-error': errors.defendant_lawyer_email }"/>
          <div class="input-error-message" v-if="errors.defendant_lawyer_email">{{ errors.defendant_lawyer_email[0] }}</div>
        </div>
      </div>
    </section-box>


    <section-box title="RSV">
      <div class="form-group mx-2 w-full">
        <p-check class="p-default p-fill" color="primary" v-model="dossier.rsv_no">
          keine RSV
        </p-check>
      </div>
      <div class="w-full" v-if="! dossier.rsv_no">
        <div class="flex w-full">
          <div class="form-group mx-2 w-1/3">
            <label class="form-label">Name der Versicherung</label>
            <input type="text" class="input w-full" v-model="dossier.rsv_name"
                   v-bind:class="{ 'input-error': errors.rsv_name }"/>
            <div class="input-error-message" v-if="errors.rsv_name">{{ errors.rsv_name[0] }}</div>
          </div>
          <div class="form-group mx-2 w-1/3">
            <label class="form-label">Schadensnummer</label>
            <input type="text" class="input w-full" v-model="dossier.rsv_customer_id"
                   v-bind:class="{ 'input-error': errors.rsv_customer_id }"/>
            <div class="input-error-message" v-if="errors.rsv_customer_id">{{ errors.rsv_customer_id[0] }}</div>
          </div>
          <div class="form-group mx-2 w-1/3">
            <label class="form-label">E-Mail</label>
            <input type="text" class="input w-full" v-model="dossier.rsv_email"
                   v-bind:class="{ 'input-error': errors.rsv_email }"/>
            <div class="input-error-message" v-if="errors.rsv_email">{{ errors.rsv_email[0] }}</div>
          </div>
        </div>
        <div class="flex w-full">
          <div class="form-group mx-2 w-1/3">
            <label class="form-label">Selbstbehalt</label>
            <currency-input
                v-model="dossier.selbstbehalt"
                currency="EUR"
                locale="de"
                class="input w-full"
            />
            <div class="input-error-message" v-if="errors.selbstbehalt">{{ errors.selbstbehalt[0] }}
            </div>
          </div>
        </div>
      </div>
    </section-box>

    <section-box title="Fahrzeug">
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Fahrzeugidentifikationsnummer</label>
          <input type="text" class="input w-full" v-model="dossier.diesel_fahrzeug_nummer"
                 v-bind:class="{ 'input-error': errors.diesel_fahrzeug_nummer }"/>
          <div class="input-error-message" v-if="errors.diesel_fahrzeug_nummer">{{ errors.diesel_fahrzeug_nummer[0] }}</div>
        </div>
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Fahrzeugbezeichnung</label>
          <input type="text" class="input w-full" v-model="dossier.diesel_fahrzeug_bezeichnung"
                 v-bind:class="{ 'input-error': errors.diesel_fahrzeug_bezeichnung }"/>
          <div class="input-error-message" v-if="errors.diesel_fahrzeug_bezeichnung">{{ errors.diesel_fahrzeug_bezeichnung[0] }}</div>
        </div>
      </div>
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">km-Stand bei Kauf</label>
          <currency-input
              v-model="dossier.diesel_fahrzeug_km_stand_uebergabe"
              :currency="null"
              locale="de"
              class="input w-full"
              :precision="0"
          />
          <div class="input-error-message" v-if="errors.diesel_fahrzeug_km_stand_uebergabe">{{ errors.diesel_fahrzeug_km_stand_uebergabe[0] }}</div>
        </div>
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">km-Stand aktuell</label>
          <currency-input
              v-model="dossier.diesel_fahrzeug_km_stand_aktuell"
              :currency="null"
              locale="de"
              class="input w-full"
              :precision="0"
          />
          <div class="input-error-message" v-if="errors.diesel_fahrzeug_km_stand_aktuell">{{ errors.diesel_fahrzeug_km_stand_aktuell[0] }}</div>
        </div>
      </div>
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Kaufpreis</label>
          <currency-input
              v-model="dossier.diesel_fahrzeug_kaufpreis"
              currency="EUR"
              locale="de"
              class="input w-full"
          />
          <div class="input-error-message" v-if="errors.diesel_fahrzeug_kaufpreis">{{ errors.diesel_fahrzeug_kaufpreis[0] }}
          </div>
        </div>
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Aktueller Marktwert</label>
          <currency-input
              v-model="dossier.diesel_aktueller_marktwert"
              currency="EUR"
              locale="de"
              class="input w-full"
          />
          <div class="input-error-message" v-if="errors.diesel_aktueller_marktwert">{{ errors.diesel_aktueller_marktwert[0] }}
          </div>
        </div>
      </div>
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Lebenslaufleistung in km</label>
          <currency-input
              v-model="dossier.diesel_fahrzeug_gesamt_laufleistung"
              :currency="null"
              locale="de"
              class="input w-full"
              :precision="0"
          />
          <div class="input-error-message" v-if="errors.diesel_fahrzeug_gesamt_laufleistung">{{ errors.diesel_fahrzeug_gesamt_laufleistung[0] }}</div>
        </div>
      </div>
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Softwareupdate bei Kauf</label>
          <p-radio class="p-icon p-round" name="diesel_softwareupdate" color="success" :value="true" v-model="dossier.diesel_softwareupdate">
            <i slot="extra" class="icon fa fa-check"></i>
            ja
          </p-radio>
          <p-radio class="p-icon p-round" name="diesel_softwareupdate" color="danger" :value="false" v-model="dossier.diesel_softwareupdate">
            <i slot="extra" class="icon fa fa-check"></i>
            nein
          </p-radio>
          <span @click="dossier.diesel_softwareupdate=null"><i class="fas fa-ban text-sm text-red-400"></i></span>
        </div>
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Bei Vertragshändler gekauft</label>
          <p-radio class="p-icon p-round" name="authorized_dealer" color="success" :value="true" v-model="dossier.authorized_dealer">
            <i slot="extra" class="icon fa fa-check"></i>
            ja
          </p-radio>
          <p-radio class="p-icon p-round" name="authorized_dealer" color="danger" :value="false" v-model="dossier.authorized_dealer">
            <i slot="extra" class="icon fa fa-check"></i>
            nein
          </p-radio>
          <span @click="dossier.authorized_dealer=null"><i class="fas fa-ban text-sm text-red-400"></i></span>
        </div>
      </div>
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Kaufdatum</label>
          <date-picker v-model="dossier.date_bought_car" valueType="format" format="DD.MM.YYYY"></date-picker>
          <div class="input-error-message" v-if="errors.date_bought_car">{{ errors.date_bought_car[0] }}</div>
        </div>
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Euro-Klasse</label>
          <p-radio class="p-icon p-round" name="diesel_fahrzeug_klasse" color="success" value="EURO5" v-model="dossier.diesel_fahrzeug_klasse">
            <i slot="extra" class="icon fa fa-check"></i>
            EURO 5
          </p-radio>
          <p-radio class="p-icon p-round" name="diesel_fahrzeug_klasse" color="success" value="EURO6" v-model="dossier.diesel_fahrzeug_klasse">
            <i slot="extra" class="icon fa fa-check"></i>
            EURO 6
          </p-radio>
          <span @click="dossier.diesel_fahrzeug_klasse=null"><i class="fas fa-ban text-sm text-red-400"></i></span>
        </div>
      </div>
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/2">
          <label class="form-label">Aktionscode</label>
          <input v-model="dossier.diesel_aktionscode" type="text" class="input w-full">
          <div class="input-error-message" v-if="errors.diesel_aktionscode">{{ errors.diesel_aktionscode[0] }}</div>
        </div>
      </div>
    </section-box>

<!--    <section-box title="Darlehen">-->
<!--      <div class="flex w-full">-->
<!--        <div class="form-group mx-2 w-1/3">-->
<!--          <label class="form-label">Darlehenskosten</label>-->
<!--          <currency-input-->
<!--              v-model="dossier.credit_costs_amount"-->
<!--              :currency="EUR"-->
<!--              locale="de"-->
<!--              class="input w-full"-->
<!--              :precision="2"-->
<!--          />-->
<!--          <div class="input-error-message" v-if="errors.credit_costs_amount">{{ errors.credit_costs_amount[0] }}</div>-->
<!--        </div>-->
<!--        <div class="form-group mx-2 w-1/3">-->
<!--          <label class="form-label">Darlehensdatum</label>-->
<!--          <date-picker v-model="dossier.credit_date" valueType="format" format="DD.MM.YYYY"></date-picker>-->
<!--          <div class="input-error-message" v-if="errors.credit_date">{{ errors.credit_date[0] }}</div>-->
<!--        </div>-->
<!--        <div class="form-group mx-2 w-1/3">-->
<!--          <label class="form-label">Darlehen abgezahlt</label>-->
<!--          <p-radio class="p-icon p-round" name="credit_payed_back" color="success" :value="true" v-model="dossier.credit_payed_back">-->
<!--            <i slot="extra" class="icon fa fa-check"></i>-->
<!--            ja-->
<!--          </p-radio>-->
<!--          <p-radio class="p-icon p-round" name="credit_payed_back" color="danger" :value="false" v-model="dossier.credit_payed_back">-->
<!--            <i slot="extra" class="icon fa fa-check"></i>-->
<!--            nein-->
<!--          </p-radio>-->
<!--          <span @click="dossier.credit_payed_back=null"><i class="fas fa-ban text-sm text-red-400"></i></span>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="flex w-full">-->
<!--        <div class="form-group mx-2 w-1/3">-->
<!--          <label class="form-label">Name der Bank</label>-->
<!--          <input type="text" class="input w-full" v-model="dossier.credit_bankname"-->
<!--                 v-bind:class="{ 'input-error': errors.credit_bankname }"/>-->
<!--          <div class="input-error-message" v-if="errors.credit_bankname">{{ errors.credit_bankname[0] }}</div>-->
<!--        </div>-->
<!--        <div class="form-group mx-2 w-1/3">-->
<!--          <label class="form-label">Darlehensnummer</label>-->
<!--          <input type="text" class="input w-full" v-model="dossier.credit_number"-->
<!--                 v-bind:class="{ 'input-error': errors.credit_number }"/>-->
<!--          <div class="input-error-message" v-if="errors.credit_number">{{ errors.credit_number[0] }}</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section-box>-->

<!--    <section-box title="Prolongation">-->
<!--      <div class="flex w-full">-->
<!--        <div class="form-group mx-2 w-1/3">-->
<!--          <label class="form-label">Prolongationskosten</label>-->
<!--          <currency-input-->
<!--              v-model="dossier.credit_prolongation_costs_amount"-->
<!--              :currency="EUR"-->
<!--              locale="de"-->
<!--              class="input w-full"-->
<!--              :precision="2"-->
<!--          />-->
<!--          <div class="input-error-message" v-if="errors.credit_prolongation_costs_amount">{{ errors.credit_prolongation_costs_amount[0] }}</div>-->
<!--        </div>-->
<!--        <div class="form-group mx-2 w-1/3">-->
<!--          <label class="form-label">Prolongationsdatum</label>-->
<!--          <date-picker v-model="dossier.credit_prolongation_date" valueType="format" format="DD.MM.YYYY"></date-picker>-->
<!--          <div class="input-error-message" v-if="errors.credit_prolongation_date">{{ errors.credit_prolongation_date[0] }}</div>-->
<!--        </div>-->
<!--        <div class="form-group mx-2 w-1/3">-->
<!--          <label class="form-label">Prolongation abgezahlt</label>-->
<!--          <p-radio class="p-icon p-round" name="credit_prolongation_payed_back" color="success" :value="true" v-model="dossier.credit_prolongation_payed_back">-->
<!--            <i slot="extra" class="icon fa fa-check"></i>-->
<!--            ja-->
<!--          </p-radio>-->
<!--          <p-radio class="p-icon p-round" name="credit_prolongation_payed_back" color="danger" :value="false" v-model="dossier.credit_prolongation_payed_back">-->
<!--            <i slot="extra" class="icon fa fa-check"></i>-->
<!--            nein-->
<!--          </p-radio>-->
<!--          <span @click="dossier.credit_prolongation_payed_back=null"><i class="fas fa-ban text-sm text-red-400"></i></span>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="flex w-full">-->
<!--        <div class="form-group mx-2 w-1/3">-->
<!--          <label class="form-label">Name der Bank</label>-->
<!--          <input type="text" class="input w-full" v-model="dossier.credit_prolongation_bankname"-->
<!--                 v-bind:class="{ 'input-error': errors.credit_prolongation_bankname }"/>-->
<!--          <div class="input-error-message" v-if="errors.credit_prolongation_bankname">{{ errors.credit_prolongation_bankname[0] }}</div>-->
<!--        </div>-->
<!--        <div class="form-group mx-2 w-1/3">-->
<!--          <label class="form-label">Prolongationsnummer</label>-->
<!--          <input type="text" class="input w-full" v-model="dossier.credit_prolongation_number"-->
<!--                 v-bind:class="{ 'input-error': errors.credit_prolongation_number }"/>-->
<!--          <div class="input-error-message" v-if="errors.credit_prolongation_number">{{ errors.credit_prolongation_number[0] }}</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section-box>-->


    <section-box title="Vermittler">
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/3">
          <label class="form-label">Vermittler</label>
          <input type="text" class="input w-full" v-model="dossier.referrer_name"
                 v-bind:class="{ 'input-error': errors.referrer_name }"/>
          <div class="input-error-message" v-if="errors.referrer_name">{{ errors.referrer_name[0] }}</div>
        </div>
        <div class="form-group mx-2 w-1/3">
          <label class="form-label">Auszahlung an Vermittler</label>
          <input type="text" class="input w-full" v-model="dossier.referrer_payout"
                 v-bind:class="{ 'input-error': errors.referrer_payout }"/>
          <div class="input-error-message" v-if="errors.referrer_payout">{{ errors.referrer_payout[0] }}</div>
        </div>
      </div>
    </section-box>


    <section-box title="Gericht">
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/3">
          <label class="form-label">Gericht</label>
          <select v-model="dossier.court_id" class="input w-full">
            <option v-for="court in courts" :key="court[1]" :value="court[1]">
              {{ court[0] }}
            </option>
          </select>
        </div>
        <div class="form-group mx-2 w-1/3">
          <label class="form-label">Aktenzeichen bei Gericht</label>
          <input type="text" class="input w-full" v-model="dossier.court_reference_number"
                 v-bind:class="{ 'input-error': errors.court_reference_number }"/>
          <div class="input-error-message" v-if="errors.court_reference_number">{{ errors.court_reference_number[0] }}</div>
        </div>
        <div class="form-group mx-2 w-1/3">
          <label class="form-label">Telefonnummer</label>
          <input type="text" class="input w-full" v-model="dossier.court_phone"
                 v-bind:class="{ 'input-error': errors.court_phone }"/>
          <div class="input-error-message" v-if="errors.court_phone">{{ errors.court_phone[0] }}</div>
        </div>
      </div>
    </section-box>


    <section-box title="Berufungsgericht">
      <div class="flex w-full">
        <div class="form-group mx-2 w-1/3">
          <label class="form-label">Gericht</label>
          <select v-model="dossier.appellate_court_id" class="input w-full">
            <option v-for="court in courts" :key="court[1]" :value="court[1]">
              {{ court[0] }}
            </option>
          </select>
        </div>
        <div class="form-group mx-2 w-1/3">
          <label class="form-label">Aktenzeichen bei Gericht</label>
          <input type="text" class="input w-full" v-model="dossier.appellate_court_reference_number"
                 v-bind:class="{ 'input-error': errors.appellate_court_reference_number }"/>
          <div class="input-error-message" v-if="errors.appellate_court_reference_number">{{ errors.appellate_court_reference_number[0] }}</div>
        </div>
        <div class="form-group mx-2 w-1/3">
          <label class="form-label">Telefonnummer</label>
          <input type="text" class="input w-full" v-model="dossier.appellate_court_phone"
                 v-bind:class="{ 'input-error': errors.appellate_court_phone }"/>
          <div class="input-error-message" v-if="errors.appellate_court_phone">{{ errors.appellate_court_phone[0] }}</div>
        </div>
      </div>
    </section-box>

    <div class="flex justify-end my-6">
      <button v-on:click="save" class="btn btn-primary">Speichern</button>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/de';
import moment from 'moment';

export default {
  components: {DatePicker},
  props: [
    'actionUrl',
    'method',
    'initialDossier',
    'attorneys',
    'principalSalutations',
    'defendants',
    'courts',
  ],
  data() {
    return {
      dossier: JSON.parse(JSON.stringify(this.initialDossier)),
      errors: [],
    }
  },
  methods: {
    save: function () {
      this.$http[this.method](this.actionUrl, {diesel_dossier: this.dossier}).then(response => {
        console.log(response.body)
        Vue.$toast.success('Vorgang wurde gespeichert.')
        window.location.href = response.body.html_path
      }, response => {
        console.log(response)
        if (response.status = 422) {
          this.errors = response.body;
        }
      })
    },
  },

  mounted: function () {
    this.dossier.date_bought_car = moment(this.dossier.date_bought_car, "YYYY-MM-DD").format("DD.MM.YYYY");
    this.dossier.credit_date = moment(this.dossier.credit_date, "YYYY-MM-DD").format("DD.MM.YYYY");
    this.dossier.credit_prolongation_date = moment(this.dossier.credit_prolongation_date, "YYYY-MM-DD").format("DD.MM.YYYY");
  }
}
</script>
